import { useState } from 'react';

const useTimeMachine = (initialState = null, bufferSize = 5) => {
  const [undoStack, setUndoStack] = useState(initialState !== null ? [initialState] : []);
  const [redoStack, setRedoStack] = useState([]);
  const [currentState, setCurrentState] = useState(initialState);

  const canUndo = undoStack.length > 1;
  const canRedo = redoStack.length > 0;

  const truncateStack = stack => stack.slice(0, bufferSize);

  const storeState = newState => {
    setUndoStack(prevUndoStack => {
      const truncatedUndoStack = truncateStack(prevUndoStack);
      return [newState, ...truncatedUndoStack];
    });
    setRedoStack([]);
    setCurrentState(newState);
  };

  const undo = () => {
    if (!canUndo) return;

    const [, ...remainingUndoStack] = undoStack;

    setRedoStack([currentState, ...redoStack]);
    setUndoStack(remainingUndoStack);
    setCurrentState(remainingUndoStack[0]);
  };

  const redo = () => {
    if (!canRedo) return;

    const [nextState, ...remainingRedoStack] = redoStack;
    const truncatedUndoStack = truncateStack(undoStack);

    setUndoStack([nextState, ...truncatedUndoStack]);
    setRedoStack(remainingRedoStack);
    setCurrentState(nextState);
  };

  const reset = (newInitialState = null) => {
    setUndoStack(newInitialState !== null ? [newInitialState] : []);
    setRedoStack([]);
    setCurrentState(newInitialState);
  };

  return {
    currentState,
    storeState,
    undo,
    redo,
    reset,
    canUndo,
    canRedo,
  };
};


export default useTimeMachine;
